import Button from '@/common/components/Button'
import ImageWithDisplayName from '@/common/components/ImageWithDisplayName'
import { solicitationKindTranslation } from '@/common/constants/maintenance/solicitationKind.constant'
import { solicitationStatusTranslation } from '@/common/constants/maintenance/solicitationStatus.constant'
import {
  MaintenanceSolicitationData,
  MaintenanceSolicitationTableItem,
} from '@/common/types/maintenance/maintenanceSolicitation'
import { formatDateTime } from '@/common/utils/formatters'
import { ArrowBigRight, CarIcon, User2Icon } from 'lucide-react'
import { Link } from 'react-router-dom'

export class MaintenanceSolicitationsTransformer {
  static tableTransformer({ companyId }: { companyId?: string }) {
    return (solicitations: MaintenanceSolicitationData[]): MaintenanceSolicitationTableItem[] => {
      return solicitations.map((solicitation) => {
        return {
          id: solicitation.id,
          status:
            solicitationStatusTranslation[solicitation.status as keyof typeof solicitationStatusTranslation] ||
            solicitation.status,
          equipment: (
            <ImageWithDisplayName
              imageUrl={solicitation?.photos?.[0]?.url || ''}
              displayName={solicitation.equipment?.field_for_display_value || ''}
              placeholderIcon={CarIcon}
            />
          ),
          author: solicitation.creator ? (
            <ImageWithDisplayName
              imageUrl={solicitation.creator?.profile_picture?.url || ''}
              displayName={solicitation.creator.full_name}
              placeholderIcon={User2Icon}
            />
          ) : (
            ''
          ),
          kind:
            solicitationKindTranslation[solicitation.kind as keyof typeof solicitationKindTranslation] ||
            solicitation.kind,
          observations: solicitation.observations,
          maintenance_program: '',
          rule_reached: '',
          created_at: formatDateTime(new Date(solicitation.created_at)),
          action: (
            <Link to={`/companies/${companyId}/maintenance/solicitations/${solicitation.id}`}>
              <Button
                variant="link-white"
                className="w-full"
                operationKlassToCheckPermission="Admin::Maintenance::Solicitations::Show"
              >
                <ArrowBigRight />
              </Button>
            </Link>
          ),
        }
      })
    }
  }
}
